<template>
  <div class="bg_white harmony-course-page">
    <van-nav-bar :title="title" left-text="" left-arrow fixed background="#fff" @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon name="wap-home-o" size="20" />
      </template>
    </van-nav-bar>

    <div class="bottombox"></div>
    <div id="common-video" class="h-100">
      <video
        ref="myVideo"
        :poster="poster"
        :src="src"
        :controls="controls"
        preload="metadata"
        playsinline
        webkit-playsinline="true"
        x5-playsinline=""
        x5-video-player-type="h5"
        x5-video-player-fullscreen="false"
        controlslist="nodownload"
        oncontextmenu="return false"
        class="video-box"
        @loadedmetadata="handleVideoReady"
        @loadeddata="handleVideoLoadedData"
        @canplay="handleVideoReady"
        @timeupdate="timeupdate"
        @seeking="handleSeeking"
        @ratechange="onRateChange"
        @play="handleVideoPlay"
        @pause="handleVideoPause"
        @ended="handleVideoEnded"
        @error="handleVideoError"
      >
        当前浏览器不支持 HTML5 video 标签
      </video>
      <button v-show="!videoState" type="button" class="custom-play-btn" @click="operateVideo">
        <span class="play-icon">▶</span>
        <span>{{ ifready ? '开始学习' : '加载中' }}</span>
      </button>
    </div>

    <van-tabs v-model="active">
      <van-tab title="课程章节">
        <van-collapse v-model="activeNames">
          <van-collapse-item v-for="item in sectionlist" :title="'第' + item + '章'" :name="item" :key="item">
            <van-cell
              v-for="(course,index) in courseList"
              center
              v-show="course.sysCourse.chapter + '' == item"
              :title-class="{'active':courseNow==index}"
              :title="course.sysCourse.title"
              :key="course.sysCourse.id"
              is-link
              @click="study(index)"
            >
              <template #label>
                <div class="flex fl_bw">
                  <span v-if="course.isNeed==1" style="color: red;">必修</span>
                  <span>时长: {{ course.sysCourse.duration }} </span>
                  <span>已学: {{ getTime(course.studyTime) }}</span>
                  <span v-if="course.studyStatus ==1" style="color: #1989fa;">已完成</span>
                </div>
              </template>
            </van-cell>
          </van-collapse-item>
        </van-collapse>
      </van-tab>
      <van-tab title="课程记录">
        <ul class="courseDetail">
          <li v-for="course in courseList" :key="course.sysCourse.id">
            <span>{{course.sysCourse.title}}</span>
            <span style="color: #1989fa;">{{course.studyStatus ==1?'已完成':'未完成'}}</span>
          </li>
        </ul>
      </van-tab>
    </van-tabs>

    <van-overlay :show="showCheckFace">
      <div class="wrapper" @click.stop>
        <div class="compareFace">
          <van-cell-group>
            <template #title>
              <span class="title">点击实时人脸识别：</span>
            </template>
            <div class="pd16 flex upImg">
              <van-uploader v-model="file1" multipart :max-count="1" upload-text="点我拍照" :before-read="beforeRead" :after-read="afterRead" capture="camera">
                <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span><span>点我拍照</span>
              </van-uploader>
            </div>
          </van-cell-group>

          <div class="pd16 m40">
            <van-button class="btn_bg" round block type="default" size="normal" @click="submitCompareFace">提交认证</van-button>
          </div>
        </div>
      </div>
    </van-overlay>

    <div class="bottombox"></div>
    <van-button type="info" block class="fixedBottom" @click="operateVideo">{{videoState?'学习中':'开始学习'}}</van-button>
  </div>
</template>

<script>
import * as imageConversion from 'image-conversion'
import { getCourseDetail, getCourseProject, saveStudyTime, studyCompareFace } from '../../api/course'
import { upload } from '../../api/upload'

const VIDEO_HOST = 'http://fzyjs.fzsyjxh.com/'
const STUDY_SAVE_INTERVAL = 5000
const STUDY_CHECK_INTERVAL = 20 * 60 * 1000

export default {
  data() {
    return {
      ifCheckFace: false,
      comparFaceParam: {
        upPhoto: '',
        id: null
      },
      file1: [],
      showCheckFace: false,
      compareFaceTimer: null,
      ifready: false,
      isDestroyingVideoStudy: false,
      courseNow: null,
      title: '',
      activeNames: ['1'],
      active: 0,
      src: '',
      hostdomain: VIDEO_HOST,
      videoState: false,
      param: {
        courseId: '',
        duration: '',
        projectId: null
      },
      studyTime: {
        currentTime: 0,
        duration: 0
      },
      timer: null,
      pauseTimer: null,
      poster: '',
      controls: true,
      startTime: 0,
      maxStudyTime: 0,
      isRestoringProgress: false,
      courseList: [],
      sectionlist: []
    }
  },
  created() {
    this.param.projectId = this.common.getQueryString('id')
  },
  mounted() {
    console.log('进入鸿蒙课程学习页')
    this.getDetail()
  },
  beforeDestroy() {
    this.destroyVideoStudy()
  },
  destroyed() {
    this.destroyVideoStudy()
  },
  methods: {
    startCheckFaceTime() {
      console.log('开启人脸识别定时器')
      this.closeCheckFaceTime()
      this.compareFaceTimer = setTimeout(() => {
        this.subStudytime()
        this.closePauseTimer()
        this.operateCompare()
      }, STUDY_CHECK_INTERVAL)
    },
    closeCheckFaceTime() {
      console.log('关闭人脸识别定时器')
      clearTimeout(this.compareFaceTimer)
      this.compareFaceTimer = null
    },
    submitCompareFace() {
      console.log('提交人脸认证')
      if (!this.comparFaceParam.id) {
        this.$toast({ message: '请先选择课程！' })
        return false
      }
      if (!this.comparFaceParam.upPhoto) {
        this.$toast({ message: '请先拍照上传人脸照片！' })
        return false
      }
      studyCompareFace(this.comparFaceParam).then(res => {
        if (res.success) {
          this.$toast({
            type: 'success',
            message: '认证通过',
            onClose: () => {
              this.showCheckFace = false
              this.file1 = []
              this.comparFaceParam.upPhoto = ''
              this.operateVideo()
            }
          })
        } else {
          this.$dialog.alert({
            message: res.message || '认证失败，请重新认证！',
            theme: 'round-button',
            confirmButtonText: '确定'
          }).then(() => {
            console.log(res.message)
            if (res.code == 270) {
              this.$router.push('/upload')
            } else if (res.code == 260) {
              this.$router.push('/bindCard')
            }
          })
        }
      }).catch(err => {
        console.log('人脸认证异常', err)
        this.$toast({ message: '认证请求失败，请稍后重试！' })
      })
      return true
    },
    beforeRead(file) {
      const validateFile = item => {
        if (!item.type.startsWith('image')) {
          this.$toast('请上传图片！')
          return false
        }
        if (item.size > 10485760) {
          this.$toast('图片超过10M！')
          return false
        }
        return true
      }
      if (Array.isArray(file)) {
        const isValid = file.every(item => validateFile(item))
        if (!isValid) {
          return false
        }
      } else if (!validateFile(file)) {
        return false
      }
      return new Promise((resolve, reject) => {
        imageConversion.compressAccurately(file, {
          size: 300,
          scale: 0.6
        }).then(res => {
          resolve(new File([res], file.name, { type: res.type, lastModified: Date.now() }))
        }).catch(err => {
          console.log('人脸照片压缩失败', err)
          this.$toast({ message: '图片压缩失败，请重新拍照！' })
          reject(err)
        })
      })
    },
    afterRead(file) {
      console.log('上传人脸照片')
      file.status = 'uploading'
      file.message = 'uploading...'
      upload(file).then(res => {
        console.log(res)
        const resp = res.data
        if (resp.success) {
          this.comparFaceParam.upPhoto = resp.data.fileName
          file.status = 'success'
          file.message = 'success'
        } else {
          file.status = 'failed'
          file.message = 'failed'
          this.$toast({ message: resp.message || '照片上传失败，请重试！' })
        }
      }).catch(err => {
        console.log('人脸照片上传异常', err)
        file.status = 'failed'
        file.message = 'failed'
        this.$toast({ message: '照片上传失败，请检查网络后重试！' })
      })
    },
    getTime(time) {
      const total = parseInt(time || 0, 10)
      let h = parseInt(total / 60 / 60 % 24, 10)
      h = h < 10 ? '0' + h : h
      let m = parseInt(total / 60 % 60, 10)
      m = m < 10 ? '0' + m : m
      let s = parseInt(total % 60, 10)
      s = s < 10 ? '0' + s : s
      return h + ':' + m + ':' + s
    },
    getDetail() {
      console.log('获取课程详情', this.param.projectId)
      getCourseDetail(this.param.projectId).then(res => {
        console.log(res.data.result)
        this.sectionlist = res.data.result.sectionlist
        this.courseList = res.data.result.courseDetailList
      }).catch(err => {
        console.log('获取课程详情失败', err)
        this.$toast({ message: '获取课程详情失败，请稍后重试！' })
      })
      getCourseProject(this.param.projectId).then(res => {
        console.log(res.data.result)
        if (res.success) {
          this.title = res.data.result.name
          this.ifCheckFace = res.data.result.checkFace == 1
        }
      }).catch(err => {
        console.log('获取课程项目失败', err)
      })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push('/home')
    },
    study(index) {
      console.log('选择课程', index)
      const course = this.courseList[index]
      if (!course || !course.sysCourse) {
        this.$toast({ message: '课程数据异常，请刷新后重试！' })
        return false
      }
      if (this.courseNow == index) {
        this.$toast({ message: '已选择该课程，点击开始学习' })
        return false
      }
      this.pauseVideoOnly()
      this.closeTimer(false)
      this.closePauseTimer()
      this.closeCheckFaceTime()
      this.videoState = false
      this.ifready = false
      this.courseNow = index
      this.param.courseId = course.sysCourse.id
      this.param.duration = course.studyTime || 0
      this.comparFaceParam.id = course.sysCourse.id
      this.startTime = course.studyTime || 0
      this.maxStudyTime = course.studyTime || 0
      this.src = encodeURI(this.hostdomain + course.sysCourse.vedioUrl)
      console.log('当前视频地址', this.src)

      if (this.ifCheckFace) {
        const userAgent = window.navigator.userAgent
        if (!/Mobile|iPad|iPhone|iPod|HarmonyOS|ArkWeb/i.test(userAgent)) {
          alert('未检测到摄像头，请使用手机进行观看！')
          return false
        }
        this.operateCompare()
      }
      return true
    },
    openTimer() {
      this.closeTimer(false)
      this.timer = setInterval(() => {
        this.$emit('videoStudyTime', this.studyTime)
        this.subStudytime()
      }, STUDY_SAVE_INTERVAL)
    },
    closeTimer(ifSubmit = true) {
      if (ifSubmit) {
        this.subStudytime()
      }
      clearInterval(this.timer)
      this.timer = null
      this.$emit('videoStudyTime', this.studyTime)
    },
    openPauseTimer() {
      console.log('开启暂停定时器')
      this.closePauseTimer()
      this.pauseTimer = setTimeout(() => {
        this.subStudytime()
        this.hintOperate()
      }, STUDY_CHECK_INTERVAL)
    },
    closePauseTimer() {
      console.log('关闭暂停定时器')
      clearTimeout(this.pauseTimer)
      this.pauseTimer = null
    },
    hintOperate() {
      console.log('弹出继续学习提醒')
      this.pauseVideoOnly()
      this.closePauseTimer()
      this.closeCheckFaceTime()
      this.$dialog.alert({
        message: '请点击确认继续学习'
      }).then(() => {
        this.operateVideo()
      })
    },
    operateCompare() {
      console.log('弹出人脸识别窗口')
      this.pauseVideoOnly()
      this.closePauseTimer()
      this.closeCheckFaceTime()
      this.file1 = []
      this.comparFaceParam.upPhoto = ''
      this.showCheckFace = true
    },
    onRateChange() {
      if (this.$refs.myVideo && this.$refs.myVideo.playbackRate !== 1.0) {
        this.$refs.myVideo.playbackRate = 1.0
        console.log('当前播放速度' + this.$refs.myVideo.playbackRate)
      }
    },
    timeupdate(e) {
      if (this.courseNow === null || !this.courseList[this.courseNow]) {
        return false
      }
      const currentTime = e.target.currentTime || 0
      const allowTime = Math.max(this.maxStudyTime, this.courseList[this.courseNow].studyTime || 0)
      if (currentTime <= 0) {
        console.log('还未开始')
      } else if (currentTime - allowTime < 1.5 || this.isRestoringProgress) {
        this.isRestoringProgress = false
        this.maxStudyTime = Math.max(this.maxStudyTime, currentTime)
        this.param.duration = currentTime
        this.courseList[this.courseNow].studyTime = currentTime
        this.studyTime.currentTime = currentTime
        this.studyTime.duration = e.target.duration ? e.target.duration : 0
      } else {
        this.rollbackFastForward(allowTime)
      }
      return true
    },
    handleSeeking(e) {
      if (this.courseNow === null || !this.courseList[this.courseNow] || this.isRestoringProgress) {
        return false
      }
      const currentTime = e.target.currentTime || 0
      const allowTime = Math.max(this.maxStudyTime, this.courseList[this.courseNow].studyTime || 0)
      if (currentTime - allowTime >= 1.5) {
        this.rollbackFastForward(allowTime)
      }
      return true
    },
    rollbackFastForward(allowTime) {
      console.log('检测到快进，回退到已学进度', allowTime)
      this.$toast({ message: '禁止快进，已回退到当前学习进度！' })
      this.isRestoringProgress = true
      this.$refs.myVideo.currentTime = allowTime
      this.param.duration = allowTime
      if (this.courseNow !== null && this.courseList[this.courseNow]) {
        this.courseList[this.courseNow].studyTime = allowTime
      }
    },
    operateVideo() {
      if (!this.src) {
        this.$toast({ message: '请先选择课程！' })
        return false
      }
      if (!this.isVideoReady()) {
        this.$toast({ message: '视频未完成加载！' })
        return false
      }
      this.ifready = true
      if (this.$refs.myVideo.paused) {
        this.videoState = true
        const playPromise = this.$refs.myVideo.play()
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(err => {
            console.log('视频播放失败', err)
            this.videoState = false
            this.closePauseTimer()
            this.closeCheckFaceTime()
            this.$toast({ message: '视频播放失败，请重新点击开始学习！' })
          })
        }
        if (this.ifCheckFace) {
          this.closePauseTimer()
          this.startCheckFaceTime()
        } else {
          this.openPauseTimer()
        }
      } else {
        this.pauseVideoOnly()
        this.closePauseTimer()
        this.closeCheckFaceTime()
      }
      return true
    },
    pauseVideoOnly() {
      if (this.$refs.myVideo && !this.$refs.myVideo.paused) {
        this.$refs.myVideo.pause()
      }
      this.videoState = false
    },
    handleVideoReady(e) {
      console.log('视频可播放')
      this.markVideoReady(e)
    },
    markVideoReady(e) {
      const video = e && e.target ? e.target : this.$refs.myVideo
      this.ifready = true
      this.studyTime.duration = video && video.duration ? video.duration : this.studyTime.duration
      if (this.startTime > 0 && video) {
        this.isRestoringProgress = true
        this.maxStudyTime = Math.max(this.maxStudyTime, this.startTime)
        video.currentTime = this.startTime
        this.startTime = 0
      }
    },
    isVideoReady() {
      const video = this.$refs.myVideo
      return this.ifready || !!(video && video.readyState >= 1)
    },
    handleVideoLoadedData(e) {
      console.log('视频首帧加载完成')
      this.markVideoReady(e)
    },
    handleVideoPlay() {
      console.log('video is playing')
      this.videoState = true
      this.openTimer()
    },
    handleVideoPause() {
      console.log('video is stop')
      this.videoState = false
      this.closeTimer()
    },
    handleVideoEnded() {
      console.log('video is ended')
      this.subStudytime()
      this.closeTimer(false)
      this.closePauseTimer()
      this.closeCheckFaceTime()
      this.videoState = false
    },
    handleVideoError() {
      const error = this.$refs.myVideo && this.$refs.myVideo.error
      console.log('视频加载失败', error && error.code, error)
      this.ifready = false
      this.videoState = false
      this.$toast({ message: '视频加载失败，请检查视频地址或格式！' })
    },
    destroyVideoStudy() {
      if (this.isDestroyingVideoStudy) {
        return false
      }
      this.isDestroyingVideoStudy = true
      console.log('销毁视频学习监控')
      this.subStudytime()
      this.closePauseTimer()
      this.closeTimer(false)
      this.closeCheckFaceTime()
      return true
    },
    subStudytime() {
      if (!this.param.projectId || !this.param.courseId || this.param.duration === '') {
        console.log('学习进度参数不完整，跳过提交', this.param)
        return false
      }
      saveStudyTime(this.param).then(res => {
        console.log(res.data)
      }).catch(err => {
        console.log('提交学习进度失败', err)
      })
      return true
    }
  }
}
</script>

<style lang="less">
.harmony-course-page {
  min-height: 100vh;
  background: #fff;
}

.courseDetail li {
  padding: 3px 18px;
  display: flex;
  justify-content: space-between;
  list-style: none;
  line-height: 18px;
}

#common-video {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #000;
}

.video-box {
  box-sizing: border-box;
  border: 0;
  display: block;
  width: 100%;
  min-height: 230px;
  background: #000;
  outline: none !important;
}

.custom-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 90px;
  color: #fff;
  background: rgba(25, 137, 250, 0.88);
  border: 0;
  border-radius: 12px;
  transform: translate(-50%, -50%);
}

.custom-play-btn span:last-child {
  margin-top: 4px;
  font-size: 14px;
}

.play-icon {
  font-size: 32px;
  line-height: 1;
}

.van-overlay {
  z-index: 1000 !important;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 1000000000000;
}

.compareFace {
  border-radius: 10px;
  width: 80%;
  height: 250PX;
  background-color: #fff;
}

.active {
  color: red;
}

.bottombox {
  width: 100%;
  height: 46px;
}
</style>
